import { core, toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  isInitialized: boolean;
  roles: core.AssignedPatronRole[];
}

const initialState: State = {
  isInitialized: false,
  roles: [],
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.BUSINESS_ROLES_FETCH_ALL_DONE:
      return {
        ...state,
        roles: toJSONArray(payload),
        isInitialized: true,
      };
    case AppConstants.BUSINESS_ROLES_FETCH_ALL_STARTING:
      return {
        ...state,
        isInitialized: false,
      };
    case AppConstants.BUSINESS_ROLES_FETCH_ALL_FAILED:
      return {
        ...state,
        isInitialized: true,
      };
    default:
      return state;
  }
}
